import { makeGetSingleFromApi } from '../make-api'

const baseUrl = '/vehicle/maxterm?year={year}&mileage={mileage}'

const vehicleApi = {
  getMaxTerm: makeGetSingleFromApi(baseUrl),
}

export default vehicleApi
